import type { IframePoolItem } from '../../../modules/api';

/** The section of the cards that carry no tier, as the design names it. */
export const UNTIERED_TITLE = 'Potential Hits';

export type TierSection = { title: string; items: IframePoolItem[] };

/**
 * The hits cut into their tiers (repackz-handoff §8.1): the backend hands
 * them over dearest first, so a tier's cards come together, and a new
 * section opens wherever the tier changes.
 */
export function groupByTier(items: IframePoolItem[]): TierSection[] {
  return items.reduce<TierSection[]>((sections, item) => {
    const title = item.tierName ?? UNTIERED_TITLE;
    const current = sections[sections.length - 1];
    if (current?.title === title) {
      return [...sections.slice(0, -1), { title, items: [...current.items, item] }];
    }
    return [...sections, { title, items: [item] }];
  }, []);
}
